// Application configuration
export const APP_CONFIG = {
  name: process.env.REACT_APP_NAME || 'Motor Approval',
  homepageUrl: process.env.REACT_APP_HOMEPAGE_URL || '/',
  applicationUrl: process.env.REACT_APP_APPLICATION_URL || '/application',
  phone: process.env.REACT_APP_PHONE || '',
  email: process.env.REACT_APP_EMAIL || '',
  description: process.env.REACT_APP_DESCRIPTION || 'Your trusted partner for car financing solutions. We deliver excellence through cutting-edge technology and exceptional service.',
};
